import styled from 'styled-components';

export const SubbodyText = styled.p<{
  grey?: boolean;
}>`
  font-size: 12px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) =>
    props.grey
      ? props.theme.atlas.semantic.color.type.disabled
      : props.theme.atlas.semantic.color.type.default};
`;
